import { useEffect, useState } from 'react';

/** Aligned with CSS/Tailwind tokens: sm 640 / md 768 / lg 1024 / xl 1280 */
export const BP = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type ViewportInfo = {
  width: number;
  height: number;
  /** &lt; 768 */
  isPhone: boolean;
  /** 768–1023 */
  isTablet: boolean;
  /** ≥ 1024 */
  isDesktop: boolean;
  /** &lt; 1024 */
  isCompact: boolean;
  isTouch: boolean;
};

function readViewport(): ViewportInfo {
  const width = typeof window !== 'undefined' ? window.innerWidth : BP.lg;
  const height = typeof window !== 'undefined' ? window.innerHeight : 800;
  const isPhone = width < BP.md;
  const isTablet = width >= BP.md && width < BP.lg;
  const isDesktop = width >= BP.lg;
  const isTouch =
    typeof window !== 'undefined' &&
    (navigator.maxTouchPoints > 0 || window.matchMedia('(pointer: coarse)').matches);
  return {
    width,
    height,
    isPhone,
    isTablet,
    isDesktop,
    isCompact: !isDesktop,
    isTouch,
  };
}

export function useViewport(): ViewportInfo {
  const [vp, setVp] = useState<ViewportInfo>(() => readViewport());

  useEffect(() => {
    const onResize = () => setVp(readViewport());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return vp;
}
